const updates = [
    "This site will be updated every Monday and Thursday",
    "On 11-Nov-24 the site was made responsive"
];

export default updates;